import { render, staticRenderFns } from "./AuthLayout.vue?vue&type=template&id=147e94bc&scoped=true"
var script = {}
import style0 from "./AuthLayout.vue?vue&type=style&index=0&id=147e94bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "147e94bc",
  null
  
)

export default component.exports